import { AsyncSingleSelectField, Button, CharField, Flex, H1, useBreadcrumbs } from "@inmagik/magik-ui"
import Layout from "../../components/Layout"
import type { FiltersBase } from "../../types"
import { useNavigate } from "react-router-dom"
import { useQsFilters } from "../../hooks/filters"
import { TablePaths } from "./TablePaths"
import { usePaths } from "../../hooks/paths"
import { useThemeLazy, useThemesLazy } from "../../hooks/themes"

const initFilters = (params: URLSearchParams) =>
  ({
    page: Number(params.get("page") ?? 1),
    search: params.get("search") ?? "",
    ordering: params.get("ordering") ?? "name",
    theme: params.get("theme") ?? "",
  }) as FiltersBase & { theme: string }

export default function Paths() {
  const { filters, uiFilters, setFilters } = useQsFilters(initFilters)

  const { data } = usePaths({
    page: String(filters.page),
    search: filters.search,
    ordering: filters.ordering,
    theme: filters.theme,
  })

  const navigate = useNavigate()

  useBreadcrumbs([{ label: "Percorsi" }])

  const fetchThemes = useThemesLazy()
  const fetchTheme = useThemeLazy()

  return (
    <Layout>
      <Flex direction="column" justifyContent="start" alignItems="stretch" className="w-100 h-100">
        <Flex alignItems="center" justifyContent="between" className="mb-5">
          <H1>Percorsi</H1>
          <Button
            size="md"
            className="text-white"
            title="Aggiungi"
            leadingIcon="add"
            onClick={() => {
              navigate("/paths/paths/new")
            }}
          />
        </Flex>
        <Flex className="mb-3" alignItems="center" gap={5}>
          <CharField
            label=""
            placeholder="Cerca..."
            leadingIcon="search"
            style={{
              width: 300,
            }}
            value={filters.search}
            onChange={(value) => {
              setFilters({ ...filters, search: value, page: 1 })
            }}
          />
          <AsyncSingleSelectField
            label=""
            placeholder="Filtra per tema"
            onChange={(value) => {
              setFilters({ ...filters, theme: value ? String(value) : "", page: 1 })
            }}
            clearable
            value={Number(filters.theme) || null}
            loadInitialValue={(id: number) => fetchTheme(id).then((theme) => ({ label: theme.name, value: theme.id }))}
            
            loadOptions={(inputValue: string) => {
              return fetchThemes({ search: inputValue }).then((themes) => {
                return themes.results?.map((theme) => ({
                  label: theme.name,
                  value: theme.id,
                }))
              })
            }}
            style={{
              width: 250,
              zIndex: 9999,
            }}
          />
        </Flex>
        <TablePaths
          paths={data?.results || []}
          setFilters={setFilters}
          filters={uiFilters}
          count={data?.count || 0}
          fullCount={data?.full_count || 0}
        />
      </Flex>
    </Layout>
  )
}
